import { useContext, useEffect, useMemo, useState } from 'react';
import minimizeModalIcon from '../../images/minimize-modal.svg';
import './StatisticsInformationModal.css';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { AppInfoContext } from '../../../../../../App';
import statisticsIcon from '../../images/statistics.svg';
import { getLabelByValue } from '../ProblemDetails';
import DMA from '../../reportproblem/components/selectOptions/DMA';
import { formatInTimeZone } from 'date-fns-tz';
import MapIcon from './images/mapa.png';
import ProblemsIcon from './images/problems.png';
import TimeIcon from './images/clock.png';
import SwitchIcon from './images/switch.jpg';
import MoneyIcon from './images/money.jpg';
import AddressIcon from './images/address.png';
import CalendarIcon from './images/calendar.png';
import PhotosIcon from './images/photos.png';
import FullScreenIcon from './images/fullscreen.png';
import { useIsMobile } from '../../reportproblem/ReportProblem';
import ReportTable from './ReportTable';
import ExportToExcel from './ExportToExcel';
import StatisticsTable from './StatisticsTable';

function StatisticsInformationModal() {
  const { appInformation, setAppInformation } = useContext(AppInfoContext);

  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVH();
    window.addEventListener('resize', setVH);
    return () => window.removeEventListener('resize', setVH);
  }, []);

  const isMobile = useIsMobile();

  const minimizeStatisticsModal = () => {
    setAppInformation((prevValue) => ({
      ...prevValue,
      statistics: {
        ...prevValue.statistics,
        statisticsMinimized: !prevValue.statistics.statisticsMinimized,
      },
    }));
  };

  const [isMinimized, setIsMinimized] = useState(
    isMobile
      ? () => {
          minimizeStatisticsModal();
          return true;
        }
      : false
  );
  const [modalAnimation, setModalAnimation] = useState(
    isMobile ? 'backInRight' : 'backOutRight'
  );

  const [graphDiagram, setGraphDiagram] = useState(true);
  const [viewMoreDetails, setViewMoreDetails] = useState(false);
  const [fullScreenTable, setFullScreenTable] = useState(false);

  const toggleAnimation = () => {
    if (!isMinimized) {
      setModalAnimation('backInRight');
      minimizeStatisticsModal();
      setIsMinimized(true);
    } else {
      setModalAnimation('backOutRight');
      setTimeout(() => {
        minimizeStatisticsModal();
        setIsMinimized(false);
      }, 600);
    }
  };

  const COLORS = ['#FFDE21', '#079C6A', '#2A4B8D'];
  const PRIORITY_COLORS = ['#21538f', '#D32F2F'];

  const renderLabel = ({ name, percent }) => {
    const percentValue = (percent * 100).toFixed(0);
    return `${name} (${percentValue}%)`;
  };

  return (
    <>
      {fullScreenTable && (
        <StatisticsTable setFullScreenTable={setFullScreenTable} />
      )}

      {!appInformation.statistics.statisticsMinimized &&
        appInformation.statistics.data && (
          <div
            className="main-si-modal "
            style={{
              display: 'block',
            }}
          >
            <div
              className={isMobile ? 'stats-main-modal-shadow' : ''}
              onClick={() => {
                toggleAnimation();
              }}
            ></div>

            <div className="stats-main-modal-container">
              <div className="stats-main-modal-header">
                <div className="stats-header-title">Statistika</div>

                <div>
                  <button
                    className="stats-header-close-button"
                    onClick={() => {
                      toggleAnimation();
                    }}
                  >
                    <img
                      src={minimizeModalIcon}
                      className="minimize-statistics-modal-icon"
                      alt="Minimize"
                    />
                  </button>
                </div>
              </div>

              <div className="statistics-main-modal-body">
                <div className="statistics-main-modal-body-title">
                  Statistika kvarova na mreži
                </div>

                {viewMoreDetails ? (
                  <>
                    <div className="statistics-field-container">
                      <div className="stats-field-title">
                        DMA sa najviše kvarova
                      </div>

                      <div className="statistics-field-details">
                        <img
                          height={20}
                          src={MapIcon}
                          alt=""
                          className="stats-field-icon"
                        />
                        <div className="stats-dma">
                          {appInformation.statistics.data.totalProblems === 0
                            ? '-'
                            : getLabelByValue(
                                appInformation.statistics.data.mostFrequentDMA
                                  .dma,
                                DMA
                              )}
                        </div>
                      </div>
                    </div>

                    <div className="statistics-field-container statistics-field-margin">
                      <div className="stats-field-title">
                        Adresa sa najviše kvarova
                      </div>

                      <div className="statistics-field-details">
                        <img
                          height={20}
                          src={AddressIcon}
                          alt=""
                          className="stats-field-icon"
                        />
                        <div className="stats-address">
                          {appInformation.statistics.data.totalProblems === 0
                            ? '-'
                            : appInformation.statistics.data.mostFrequentAddress
                                .address}
                        </div>
                      </div>
                    </div>

                    <div className="statistics-field-container statistics-field-margin">
                      <div className="stats-field-title">
                        Prijava sa fotografijom
                      </div>

                      <div className="statistics-field-details">
                        <img
                          height={20}
                          src={PhotosIcon}
                          alt=""
                          className="stats-field-icon"
                        />
                        <div className="stats-photos">
                          {appInformation.statistics.data.problemsWithImage}
                        </div>
                      </div>
                    </div>

                    <div className="stats-graph-container ">
                      <div className="stats-graph ">
                        <div className="stats-graph-title">
                          Grafik prioriteta popravke
                        </div>
                      </div>

                      <PieChart width={300} height={150}>
                        <Pie
                          data={appInformation.statistics.data.priorityCount}
                          cx="50%"
                          cy="50%"
                          labelLine={false}
                          //   label={renderLabel}
                          outerRadius={70}
                          innerRadius={37}
                          dataKey="value"
                          cornerRadius={0}
                        >
                          {appInformation.statistics.data.priorityCount.map(
                            (entry, index) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={
                                  PRIORITY_COLORS[
                                    index % PRIORITY_COLORS.length
                                  ]
                                }
                              />
                            )
                          )}
                        </Pie>
                        <Tooltip />
                        <Legend
                          layout="vertical"
                          verticalAlign="middle"
                          align="right"
                        />
                      </PieChart>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="stats-graph-container">
                      <div className="stats-time-period">Vremenski period</div>

                      <div className="stats-time-period-container">
                        <img height={20} src={CalendarIcon} alt="" />
                        <div className="stats-field-title">
                          {appInformation.statistics.data.timePeriod.from !==
                          null
                            ? formatInTimeZone(
                                appInformation.statistics.data.timePeriod.from,
                                'Europe/Paris',
                                "dd.MM.yyyy.' 'HH:mm"
                              )
                            : '/'}{' '}
                          -{' '}
                          {appInformation.statistics.data.timePeriod.to !== null
                            ? formatInTimeZone(
                                appInformation.statistics.data.timePeriod.to,
                                'Europe/Paris',
                                "dd.MM.yyyy.' 'HH:mm"
                              )
                            : formatInTimeZone(
                                new Date(),
                                'Europe/Paris',
                                "dd.MM.yyyy.' 'HH:mm"
                              )}
                        </div>
                      </div>
                    </div>

                    <div className="stats-two-columns ">
                      <div className="stats-total-problems">
                        <div className="stats-field-title">Ukupno kvarova</div>

                        <div className="stats-total-problems-container ">
                          <img height={20} src={ProblemsIcon} alt="" />
                          <div className="stats-title-numbers">
                            {appInformation.statistics.data.totalProblems}
                          </div>
                        </div>
                      </div>

                      <div className="stats-average-time-container">
                        <div className="stats-field-title">
                          Prosječno trajanje popravke
                        </div>

                        <div className="stats-average-time">
                          <img
                            height={20}
                            src={TimeIcon}
                            alt=""
                            className="stats-field-icon"
                          />
                          <div className="stats-title-numbers">
                            {appInformation.statistics.data.avgFixTime.hours ===
                            null ? (
                              '-'
                            ) : (
                              <>
                                {appInformation.statistics.data.avgFixTime
                                  .hours === 0
                                  ? ''
                                  : `${appInformation.statistics.data.avgFixTime.hours} h `}

                                {appInformation.statistics.data.avgFixTime
                                  .minutes === 0
                                  ? ''
                                  : `${appInformation.statistics.data.avgFixTime.minutes} min`}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="stats-graph-container ">
                      <div className="stats-graph">
                        <div className="stats-graph-title">
                          {graphDiagram ? 'Grafik kvarova' : 'Tabela kvarova'}
                        </div>

                        <div>
                          {!graphDiagram && (
                            <>
                              <img
                                height={30}
                                src={FullScreenIcon}
                                alt=""
                                className="stats-switch"
                                onClick={() => setFullScreenTable(true)}
                              />

                              <ExportToExcel height={30} />
                            </>
                          )}

                          <img
                            height={30}
                            src={SwitchIcon}
                            alt=""
                            className="stats-switch"
                            onClick={() =>
                              setGraphDiagram((prevState) => !prevState)
                            }
                          />
                        </div>
                      </div>

                      {graphDiagram ? (
                        <PieChart width={300} height={150}>
                          <Pie
                            data={
                              appInformation.statistics.data.problemStatusCount
                            }
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            //   label={renderLabel}
                            outerRadius={70}
                            innerRadius={37}
                            dataKey="value"
                            cornerRadius={0}
                          >
                            {appInformation.statistics.data.problemStatusCount.map(
                              (entry, index) => (
                                <Cell
                                  key={`cell-${index}`}
                                  fill={COLORS[index % COLORS.length]}
                                />
                              )
                            )}
                          </Pie>
                          <Tooltip />
                          <Legend
                            layout="vertical"
                            verticalAlign="middle"
                            align="right"
                          />
                        </PieChart>
                      ) : (
                        <div className="stats-table-container">
                          <ReportTable
                            setFullScreenTable={setFullScreenTable}
                          />
                        </div>
                      )}
                    </div>
                    <div className="statistics-field-container">
                      <div className="stats-field-title">
                        Prosječni trošak popravke kvara
                      </div>

                      <div className="statistics-field-details">
                        <img
                          height={30}
                          src={MoneyIcon}
                          alt=""
                          className="stats-field-icon"
                        />
                        <div className="stats-title-numbers">
                          {appInformation.statistics.data.problemStatusCount[2]
                            .value === 0 ? (
                            '-'
                          ) : (
                            <>{appInformation.statistics.data.avgExpense} KM</>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div
                  className="statistics-details-icon"
                  onClick={() => setViewMoreDetails((prevState) => !prevState)}
                >
                  {viewMoreDetails ? 'Manje detalja' : 'Više detalja'}
                </div>
              </div>
            </div>
          </div>
        )}

      {isMinimized && (
        <div
          className={`minimized-si-main-modal ${modalAnimation}`}
          onClick={() => {
            toggleAnimation();
          }}
        >
          <img src={statisticsIcon} className="minimized-si-icon " alt="Icon" />
        </div>
      )}
    </>
  );
}

export default StatisticsInformationModal;
